export const AvatarData = [
  {
    id: 98,
    name: "Ally Accessibility",
    avatarAttributes: {
      topType: "LongHairStraight2",
      accessoriesType: "Round",
      hairColor: "BlondeGolden",
      facialHairType: "Blank",
      clotheColor: "Blue02",
      eyeType: "Happy",
      eyebrowType: "Default",
      mouthType: "Twinkle",
      skinColor: "Brown",
    },
  },
  {
    id: 99,
    name: "Lily Labs",
    avatarAttributes: {
      topType: "ShortHairShaggyMullet",
      accessoriesType: "Blank",
      hairColor: "Brown",
      facialHairType: "Blank",
      facialHairColor: "Red",
      clotheColor: "Heather",
      eyeType: "Close",
      eyebrowType: "UpDownNatural",
      mouthType: "Twinkle",
      skinColor: "Yellow",
    },
  },
  {
    id: 100,
    name: "Edna Education",
    avatarAttributes: {
      topType: "LongHairNotTooLong",
      accessoriesType: "Round",
      hairColor: "BlondeGolden",
      facialHairType: "Blank",
      facialHairColor: "Black",
      clotheColor: "PastelRed",
      eyeType: "Close",
      eyebrowType: "DefaultNatural",
      mouthType: "Eating",
      skinColor: "Light",
    },
  },
];
